import React from 'react'
import { getOutletTheme } from '../../constants/outletThemes'

function OutletBadge({ theme, outletReason, children = 'Аме Outlet', className = '' }) {
  const resolvedTheme = theme || (outletReason ? getOutletTheme(outletReason) : null)

  if (!resolvedTheme) {
    return null
  }

  const classNames = ['OutletBadge', `OutletBadge--${resolvedTheme}`, className].filter(Boolean).join(' ')

  return <span className={classNames}>{children}</span>
}

export default OutletBadge
